import { render, staticRenderFns } from "./ListPasienICD.vue?vue&type=template&id=e2f46f20&scoped=true"
import script from "./ListPasienICD.vue?vue&type=script&lang=js"
export * from "./ListPasienICD.vue?vue&type=script&lang=js"
import style0 from "./ListPasienICD.vue?vue&type=style&index=0&id=e2f46f20&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f46f20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2f46f20')) {
      api.createRecord('e2f46f20', component.options)
    } else {
      api.reload('e2f46f20', component.options)
    }
    module.hot.accept("./ListPasienICD.vue?vue&type=template&id=e2f46f20&scoped=true", function () {
      api.rerender('e2f46f20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/pasienicd/ListPasienICD.vue"
export default component.exports